export const TRADE_LOCATION_CONFIG = {
  builder: {
    label: "Builders",
    serviceBullets: [
      "Extensions & Loft Conversions",
      "Kitchen & Bathroom Renovations",
      "General Repairs & Maintenance",
      "Renovations & refurbishments",
      "Tiling, Flooring & Interior Finishes",
      "Plumbing / Heating Work"
    ],
    cities: {}
  },

  carpenter: {
    label: "Carpenters",
    serviceBullets: [
      "Custom furniture",
      "Kitchen fitting",
      "Doors & architraves",
      "Wooden flooring repairs",
      "Decking & staircases",
      "Built-in storage"
    ],
    cities: {}
  },

  cleaner: {
    label: "Cleaners",
    serviceBullets: [
      "Domestic cleaning",
      "Deep cleans",
      "End-of-tenancy cleaning",
      "Carpet & upholstery",
      "Office cleaning",
      "One-off or regular visits"
    ],
    cities: {}
  },

  electrician: {
    label: "Electricians",
    serviceBullets: [
      "Full & partial rewires",
      "Fuse board upgrades",
      "Additional Lighting & sockets",
      "Electrical safety inspections (EICR)",
      "Outdoor power & EV chargers",
      "Emergency call-outs"
    ],
    cities: {}
  },

  gardener: {
    label: "Gardeners",
    serviceBullets: [
      "Lawn mowing & hedge trimming",
      "Garden clearance",
      "Planting & landscaping",
      "Patios & fencing",
      "Tree surgery",
      "Regular maintenance"
    ],
    cities: {}
  },

  painter: {
    label: "Painters & Decorators",
    serviceBullets: [
      "Interior painting",
      "Exterior painting",
      "Wallpapering",
      "Plaster patch & prep",
      "Feature walls",
      "Commercial decorating"
    ],
    cities: {}
  },

  plasterer: {
    label: "Plasterers",
    serviceBullets: [
      "Skimming",
      "Rendering",
      "Drylining",
      "Ceiling repair",
      "Plasterboarding",
      "Decorative plasterwork"
    ],
    cities: {}
  },

  plumber: {
    label: "Plumbers",
    serviceBullets: [
      "Boiler installs & servicing",
      "Radiators & underfloor heating",
      "Leak detection & pipe repairs",
      "Bathroom fitting",
      "Unblocking drains",
      "Emergency plumbing"
    ],
    cities: {}
  },

  roofer: {
    label: "Roofers",
    serviceBullets: [
      "New roofs",
      "Roof repairs",
      "Flat roofing",
      "Guttering & fascias",
      "Chimney repairs",
      "Emergency call-outs"
    ],
    cities: {}
  },

  tiler: {
    label: "Tilers",
    serviceBullets: [
      "Bathroom tiling",
      "Kitchen splashbacks",
      "Floor tiling",
      "Outdoor patios",
      "Mosaic tiling",
      "Repairs & re-grouting"
    ],
    cities: {}
  },

  handyperson: {
    label: "Handypeople",
    serviceBullets: [
      "Flat-pack assembly",
      "Small repairs",
      "Shelves & curtain rails",
      "Door adjustments",
      "Minor plumbing & electrics",
      "General odd jobs"
    ],
    cities: {}
  },

  "solar-pv": {
    label: "Solar PV Installers",
    serviceBullets: [
      "Solar panel installation",
      "Battery storage",
      "Inverter replacement",
      "System servicing",
      "Off-grid solutions",
      "Energy efficiency advice"
    ],
    cities: {}
  }
};

// --- Major UK cities to attach to each trade ---
export const MAJOR_UK_CITIES = {
  london: { 
    label: "London", 
    boroughs: ["Camden", "Brixton", "Stratford", "Shepherd’s Bush"] 
  },
  birmingham: { 
    label: "Birmingham", 
    boroughs: ["Aston", "Moseley", "Small Heath", "Edgbaston"] 
  },
  manchester: { 
    label: "Manchester", 
    boroughs: ["Cheetham Hill", "Didsbury", "Ancoats", "Salford"] 
  },
  leeds: { 
    label: "Leeds", 
    boroughs: ["Chapel Allerton", "Beeston", "Halton", "Headingley"] 
  },
  liverpool: { 
    label: "Liverpool", 
    boroughs: ["Everton", "Aigburth", "Kensington", "Walton"] 
  },
  bristol: { 
    label: "Bristol", 
    boroughs: ["Horfield", "Bedminster", "St George", "Clifton"] 
  },
  sheffield: { 
    label: "Sheffield", 
    boroughs: ["Burngreave", "Meersbrook", "Manor", "Crookes"] 
  },
  newcastle: { 
    label: "Newcastle", 
    boroughs: ["Gosforth", "Low Fell", "Byker", "Fenham"] 
  },
  nottingham: { 
    label: "Nottingham", 
    boroughs: ["Sherwood", "Clifton", "Sneinton", "Lenton"] 
  },
  glasgow: { 
    label: "Glasgow", 
    boroughs: ["Maryhill", "Pollokshields", "Dennistoun", "Partick"] 
  }
};



// --- Attach the cities to every trade (so you don’t duplicate) ---
Object.keys(TRADE_LOCATION_CONFIG).forEach(trade => {
  TRADE_LOCATION_CONFIG[trade].cities = MAJOR_UK_CITIES;
});

// --- Variants to shuffle for uniqueness ---
export const INTRO_VARIANTS = [
  ({tradeLabel, cityLabel}) =>
    `Looking for reliable ${tradeLabel.toLowerCase()} in ${cityLabel}? TradesUTrust connects you with vetted, insured professionals ready to help. Click the link below to Post your job today!`,
  ({tradeLabel, cityLabel}) =>
    `Need a ${tradeLabel.slice(0, -1).toLowerCase()} in ${cityLabel}? Post a job free on TradesUTrust and get fast quotes from trusted local specialists. Click the link below to Post your job today!`,
  ({tradeLabel, cityLabel}) =>
    `Hiring ${tradeLabel.toLowerCase()} in ${cityLabel} is simple with TradesUTrust — compare reviews, pricing, and book with confidence. Click the link below to Post your job today!`
];

export const CTA_VARIANTS = [
  "Post your job",
];

// Trade-specific guidance content (edit anytime)
export const TRADE_GUIDES = {
  electrician: {
    howToChoose: [
      "Professional electricians would either have, an ECS/Gold Card or be part of a competant persons scheme like the NICEIC, NAPIT or similar. This means they have been vetted and you can rest assured they are skilled tradespeople",
      "Competant Persons Schemes are important, because it means the electrician can self certify their work and notify building control, of any changes in your property.",
      "For socket and light fitting changes, a qualified electrician is what you need, but for additional circuits or changes to additional circuits, the electrician must be part of a CPS to certify their work.",
      "A good electrician will be able to explain in simple terms, how your job can be done, and a provide  you with a budget cost, empowering you to feel at ease when hiring."
    ],
    whatToAsk: [
      "Are you registered with a Competant Persons Scheme? Can you provide me with your registration number?",
      "Will you supply an Electrical Installation Certificate / EICR?",
      "How will you protect my property while working?",
      "Will you dispose of waste materials from the job on completion?",
      "What type of warranty do you provide on your services?"
    ],
    typicalJobs: [
      "Replace consumer unit (fuse board) — £350–£900+",
      "EICR for 2–3 bed home — £120–£250",
      "Add/relocate sockets & lighting — £80–£300",
      "Garden lighting / EV charger (excl. unit) — £200–£700"
    ]
  },

  plumber: {
    howToChoose: [
      "A professional Plumber will usually possess the relevant qualifications to undertake the job, this is typically an NVQ Level 3. ",
    'Additionally they will be registered to a compentant persons scheme like Gas Safe registration, for gas work and a WaterSafe accreditation, for water systems.',
    "For tap changes and pipe modifications, they should be qualified to NVQ Level 2 as a minimum. For any work on gas appliances, they must be registered with Gas Safe and provide a certificate on completion",
    'Most good Plumbers will ensure they are keeping up with the latest codes and practices, to ensure the are working within the regulations'
    ],
    whatToAsk: [
      "Are you Gas Safe registered? Can you provide me with your registration number?",
      "What warranty give you provide me when the works are completed",
     "How long will the job take?",
     'Is there any risk of flooding'
    ],
    typicalJobs: [
      "Fix leak / trap replacement — £60–£180",
      "Toilet repair/replace — £80–£250",
      "Radiator install/move — £120–£350",
      "Boiler service — £70–£130"
    ]
  },

  builder: {
    howToChoose: [
  "Ask to see their recent building projects and request contactable references from past clients — this gives you confidence in their workmanship and reliability.",
  "Confirm with them, that any structural work is properly designed by a qualified engineer, especially where walls or foundations are involved.",
  "Ensure that the works are properly planned, acquire an agreement on a staged payments at each milestone.",
  "Request a written programme of works that shows the timeline and who will be on site each day, to keep the project organised.",
  "Confirm that the builder carries valid employers’ liability and public liability insurance, to make sure your home is protected."
],
    whatToAsk: [
      "Do you manage building control and waste/skip permits?",
      "What trades are in-house vs subcontracted?",
      "How do you handle variations and snagging?",
      "Will you protect all working areas from residual damage?",
      "What is the defects liability/warranty period?"
    ],
   typicalJobs: [
  "Garage conversion (single) — £6,000–£15,000",
  "General refurb per room — £800–£4,000+",
  "Small loft conversion (Velux/roof-light) — £25,000–£40,000",
  "Single-storey extension — £2,200–£3,300 per m²",
  "Dormer/hip-to-gable loft conversion — £40,000–£80,000+",
  "Two-storey extension — £130,000–£150,000+"
]
  },

  carpenter: {
    howToChoose: [
      "Check portfolio for similar joinery/kitchen work.",
      "Confirm materials (solid wood vs MDF) and finish method.",
      "Ask for precise measurements and drawings before fabrication.",
      "Agree on hardware brands (hinges, runners) and lead time.",
      "Seek dust control and on-site protection plan."
    ],
    whatToAsk: [
      "Do you template and produce drawings for approval?",
      "What timber/board grade will you use?",
      "Is spray finish or hand-painting included?",
      "What aftercare is needed for the finish?",
      "What’s the warranty on hardware?"
    ],
    typicalJobs: [
      "Fitted wardrobes — £1,200–£3,500",
      "Kitchen fitting (excl. units) — £800–£2,500",
      "Door hanging (per door) — £60–£150",
      "Bespoke alcove units — £900–£2,000"
    ]
  },

  cleaner: {
    howToChoose: [
      "Ask if they supply equipment and eco-friendly products.",
      "Confirm insurance and key-holding policy if recurring.",
      "Check checklist scope and time estimate for deep cleans.",
      "Look for DBS checks if required for sensitive premises.",
      "Prefer fixed price for end-of-tenancy cleans incl. oven/carpet."
    ],
    whatToAsk: [
      "What’s included/excluded in a standard vs deep clean?",
      "Do you bring all equipment and materials?",
      "How do you handle cancellations/keys/access?",
      "Are carpets/ovens/windows included or extra?",
      "Can you provide references for similar properties?"
    ],
    typicalJobs: [
      "Weekly domestic clean (2 hrs) — £30–£50",
      "Deep clean (2–3 bed) — £120–£250",
      "End-of-tenancy (2–3 bed) — £160–£320",
      "Office clean (per visit) — £40–£120"
    ]
  },

  gardener: {
    howToChoose: [
      "Check waste carrier licence for green waste disposal.",
      "Ask about seasonal maintenance plans and plant knowledge.",
      "Confirm equipment used and access requirements.",
      "Request photos of similar gardens/landscapes.",
      "Ensure public liability insurance is in place."
    ],
    whatToAsk: [
      "Do you take away green waste and is it included?",
      "What’s your schedule in peak seasons?",
      "Which plants suit shade/full sun in my garden?",
      "Do you offer fixed monthly maintenance?",
      "Can you source materials at trade rates?"
    ],
    typicalJobs: [
      "One-off tidy (small garden) — £60–£150",
      "Hedge reduction — £80–£300",
      "New turf (per m² incl. prep) — £12–£25",
      "Patio install (per m²) — £70–£120"
    ]
  },

  painter: {
    howToChoose: [
      "Ask about prep standards (filling, sanding, caulking).",
      "Confirm paint brands/finishes and number of coats.",
      "Check for dust extraction and masking practice.",
      "Seek a sample wall/colour test before whole rooms.",
      "Ensure snagging list at handover is included."
    ],
    whatToAsk: [
      "What surface prep is included?",
      "Which paint brand/finish will you use?",
      "How will you protect floors and furniture?",
      "How many coats and is stain blocking included?",
      "What’s the drying/return-to-use time?"
    ],
    typicalJobs: [
      "Room repaint (small) — £150–£350",
      "Whole 2-bed flat — £900–£2,000",
      "Exterior front — £600–£1,500",
      "Feature wall/wallpaper — £120–£300"
    ]
  },

  plasterer: {
    howToChoose: [
      "View photos of flat, even finishes and corners.",
      "Ask how they handle bonding and backing coats.",
      "Confirm drying time guidance and paint readiness.",
      "Check dust control and room protection steps.",
      "Get clarity on repairs vs full reskim areas."
    ],
    whatToAsk: [
      "Is bonding or mesh needed for cracks?",
      "How many coats and what finish will I get?",
      "When can I paint after skim?",
      "Do you include corner beads and trims?",
      "What’s your approach to ceilings vs walls?"
    ],
    typicalJobs: [
      "Small wall repair/patch — £80–£180",
      "Room reskim — £200–£500",
      "Ceiling reskim — £150–£300",
      "Render repair — £150–£400"
    ]
  },

  roofer: {
    howToChoose: [
      "Ask for drone/photos of roof before & after.",
      "Check experience with your roof type (slate/tile/flat).",
      "Confirm scaffolding, permits, and warranties.",
      "Look for manufacturer-approved installers for flat roofs.",
      "Ensure they’ll check/clear gutters and flashings."
    ],
    whatToAsk: [
      "Do you provide photos before/after and a written warranty?",
      "Is scaffold included and who arranges it?",
      "Which membrane/felt system will you use?",
      "Will you inspect chimneys, valleys, and gutters?",
      "What’s the life expectancy of the repair/new roof?"
    ],
    typicalJobs: [
      "Tile/slate repair — £80–£250",
      "Flat roof (per m²) — £60–£120",
      "New roof (semi) — £3,500–£8,000",
      "Gutter/Fascia replacement — £300–£1,200"
    ]
  },

  tiler: {
    howToChoose: [
      "Check layouts, grout lines, and mitred edges in portfolio.",
      "Confirm substrate prep (backer boards, tanking).",
      "Ask about trims, expansion joints, and movement gaps.",
      "Verify they can work with your tile type (porcelain, stone).",
      "Prefer laser levels and dust extraction use."
    ],
    whatToAsk: [
      "How will you prep the substrate (level, tanking)?",
      "Which grout/sealant will you use?",
      "Do you recommend trims or mitred edges?",
      "How do you handle underfloor heating?",
      "What’s the cure time before use?"
    ],
    typicalJobs: [
      "Splashback — £120–£300",
      "Bathroom walls — £400–£900",
      "Floor tiling (per m²) — £25–£60",
      "Regrout/seal — £120–£280"
    ]
  },

  handyperson: {
    howToChoose: [
      "Look for multi-trade experience and photos of similar small jobs.",
      "Confirm minimum call-out and materials policy.",
      "Ask if they bring fixings/anchors and a dust sheet.",
      "Check availability for evenings/weekends if needed.",
      "Prefer clear hourly vs fixed rates."
    ],
    whatToAsk: [
      "What is your minimum charge/call-out?",
      "Do you supply fixings and small materials?",
      "Can you source and collect parts if required?",
      "How do you price multiple small tasks in one visit?",
      "What’s your availability for urgent repairs?"
    ],
    typicalJobs: [
      "Flat-pack assembly (per item) — £30–£70",
      "Curtain/blind fitting — £40–£120",
      "TV mounting — £50–£120",
      "Door adjustments/locks — £40–£120"
    ]
  },

  "solar-pv": {
    howToChoose: [
      "Look for MCS certification and RECC membership.",
      "Ask for a proper site survey (roof pitch, shading, DNO approval).",
      "Confirm panel/inverter brands and warranties.",
      "Discuss battery storage and smart export options.",
      "Request performance estimate (kWh/yr) and payback."
    ],
    whatToAsk: [
      "Are you MCS/RECC certified and will I get an MCS certificate?",
      "Do you handle DNO application and scaffolding?",
      "What panel/inverter brands do you supply and warranty terms?",
      "Is battery storage compatible now or later?",
      "What’s the estimated annual generation and payback?"
    ],
    typicalJobs: [
      "4kW PV install (no battery) — £4,500–£7,000",
      "Battery add-on (5–10kWh) — £2,000–£5,000",
      "Inverter replacement — £600–£1,500",
      "Annual service/inspection — £120–£250"
    ]
  }
};

